
<v-row dense class="table-row w-100">
    <v-col class="col-6 pl-0 name-value-label">
        {{ label }}
    </v-col>
    <v-col class="col-6">
        {{ rating }}
    </v-col>
</v-row>
